module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Pillow-Web-1280.b4fcb364.jpg";